import classNames from 'classnames/bind';
import styles from './ProjectItem2.module.scss';
import { FaExternalLinkAlt } from 'react-icons/fa';
import { useContext, useEffect, useState } from 'react';
import { LoginContext } from '../Context/LoginProvider';
import { ModalOverLayContext } from '../Context/ModalOverLayProvider';
import EditProject from '../EditProject/EditProject';
import { NavLink } from 'react-router-dom';
import routes from '~/configs';
import { splitBySpace } from '~/helper/help';
import Controller from '../Controller';

const cx = classNames.bind(styles);

function ProjectItem2({ data, handleRemove, style }) {
  const { loginStatus } = useContext(LoginContext);
  const { setModalComponentContent } = useContext(ModalOverLayContext);
  const [tags, setTags] = useState([]);

  useEffect(() => {
    setTags(splitBySpace(data?.language));
  }, []);

  const handleClickEdit = () => setModalComponentContent(<EditProject id={data.id} />);
  const handleClickDelete = (e) => handleRemove(e, data.id);
  return (
    <div className={cx('container')} style={style}>
      {loginStatus && (
        <Controller className={cx('controller')} handleEdit={handleClickEdit} handleDelete={handleClickDelete} />
      )}
      <NavLink to={`${routes.projectDetail}/${data.id}`} className={cx('content')}>
        <div className={cx('date')}>{data?.time}</div>
        <div className={cx('header')}>
          <div className={cx('title')}>{data?.name}</div>
          <div className={cx('link')}>
            <FaExternalLinkAlt />
          </div>
        </div>
        <p className={cx('description')}>{data.descriptions}</p>
        <div className={cx('tags')}>
          {tags.map((tag, index) => (
            <span key={index} className={cx('tag')}>
              {tag}
            </span>
          ))}
        </div>
      </NavLink>
    </div>
  );
}

export default ProjectItem2;
